export default __webpack_public_path__ + "static/media/Graviola-Soft-Heavy.51cc5477.otf";